<app-resource-template [footerStickyEnabled]="footerStickyEnabled">
  <div resource-content class="privacy-content" [innerHTML]="privacyContent"></div>
</app-resource-template>
